export default "__VITE_ASSET__d47cec86__"